import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { TFormData, TProps } from '.';

const FormCreateOrEditCreatorHeader = ({ readonly = false }: TProps) => {

  const { control } = useFormContext<TFormData>();
  const username = useWatch({ control, name: 'username'});
  const creatorId = useWatch({ control, name: '_id'});

  let title = 'Nouveau créateur';
  let description = 'Vous êtes sur le point de créer un nouveau créateur de contenu.';

  if (creatorId) {
    title = 'Modification du créateur';
    description = `Vous modifiez le créateur ${creatorId}`;
  }

  if (readonly) {
    title = username;
    description = 'Les détails du créateur de contenu';
  }

  return (
    <DialogHeader>
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogDescription>
        {description}
      </DialogDescription>
    </DialogHeader>
  );

};

export default FormCreateOrEditCreatorHeader;
